// "My wells" under the left menu (doc 09 §2): the wells the user can open, with their status,
// and the wells under test one click away from their live view.
import { UnstyledButton } from '@mantine/core';
import { useLocalStorage } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';
import { FiActivity, FiChevronDown, FiChevronRight } from 'react-icons/fi';
import { NavLink } from 'react-router-dom';
import { useAssetTree } from '@web/features/assets/api';
import { WellStatusLabel } from '@web/features/assets/AssetTreeView';
import classes from './MyWells.module.css';

export function MyWells({ orgId }: { orgId: string }) {
  const { t } = useTranslation();
  const tree = useAssetTree(orgId);
  const [open, setOpen] = useLocalStorage({ key: 'tl.nav.wells', defaultValue: true });
  const wells = (tree.data?.fields ?? []).flatMap((f) => f.wells);
  if (wells.length === 0) return null;
  return (
    <section className={classes.section} aria-label={t('nav.myWells')}>
      <UnstyledButton className={`tl-caption ${classes.caption}`} onClick={() => setOpen((o) => !o)} aria-expanded={open}>
        {open ? <FiChevronDown size={12} aria-hidden /> : <FiChevronRight size={12} aria-hidden />}
        {t('nav.myWells')}
      </UnstyledButton>
      {open && (
        <ul className={classes.list}>
          {wells.map((w) => (
            <li key={w.id}>
              <NavLink to={`/o/${orgId}/assets/well/${w.id}`} className={({ isActive }) => `${classes.site} ${isActive ? classes.active : ''}`}>
                <WellStatusLabel status={w.status} compact />
                <span className={classes.name}>{w.name}</span>
              </NavLink>
              {w.runningTest && (
                <ul className={classes.wells}>
                  <li>
                    <NavLink to={`/o/${orgId}/live?well=${w.id}`} className={classes.well} title={w.runningTest.name} aria-label={t('nav.liveWell', { well: w.name })}>
                      <FiActivity size={12} aria-hidden />
                      <span className={classes.name}>{w.runningTest.name}</span>
                    </NavLink>
                  </li>
                </ul>
              )}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
